import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=b9d66de2&scoped=true&lang=pug"
import script from "./Termos.vue?vue&type=script&lang=js"
export * from "./Termos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d66de2",
  null
  
)

export default component.exports